// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__WwBaP","img":"Login_img__HhXuv"};